/* tslint:disable */
/* eslint-disable */
/**
 * Masir.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AvailableJourneysDto } from '../model';
// @ts-ignore
import { City } from '../model';
// @ts-ignore
import { GetAvailableIdType } from '../model';
// @ts-ignore
import { RegisterInfoRequest } from '../model';
// @ts-ignore
import { RegisterInfoResponse } from '../model';
// @ts-ignore
import { ReserveRequest } from '../model';
// @ts-ignore
import { ReserveResponse } from '../model';
// @ts-ignore
import { SearchPriority } from '../model';
/**
 * JourneyApiApiCitiesGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function JourneyApiApiCitiesGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Cities`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * JourneyApiApiGetAvailableGet - axios parameter creator
 * 
 * @param {GetAvailableIdType} [idType] 
 * @param {string} [originId] 
 * @param {string} [destinationId] 
 * @param {string} [date] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {SearchPriority} [searchPriority] 
 * @param {boolean} [restrictServices] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function JourneyApiApiGetAvailableGetAxiosParamCreator (idType?: GetAvailableIdType, originId?: string, destinationId?: string, date?: string, adultCount?: number, childCount?: number, infantCount?: number, searchPriority?: SearchPriority, restrictServices?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetAvailable`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (idType !== undefined) {
        localVarQueryParameter['idType'] = idType;
    }

    if (originId !== undefined) {
        localVarQueryParameter['originId'] = originId;
    }

    if (destinationId !== undefined) {
        localVarQueryParameter['destinationId'] = destinationId;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['childCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['infantCount'] = infantCount;
    }

    if (searchPriority !== undefined) {
        localVarQueryParameter['searchPriority'] = searchPriority;
    }

    if (restrictServices !== undefined) {
        localVarQueryParameter['restrictServices'] = restrictServices;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * JourneyApiApiRegisterInfoPost - axios parameter creator
 * 
 * @param {RegisterInfoRequest} [registerInfoRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function JourneyApiApiRegisterInfoPostAxiosParamCreator (registerInfoRequest?: RegisterInfoRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/RegisterInfo`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerInfoRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * JourneyApiApiReservePost - axios parameter creator
 * 
 * @param {ReserveRequest} [reserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function JourneyApiApiReservePostAxiosParamCreator (reserveRequest?: ReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(reserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGetAvailableGet operation in JourneyApi.
 * @export
 * @interface JourneyApiApiGetAvailableGetRequest
 */
export interface JourneyApiApiGetAvailableGetRequest {
    /**
     * 
     * @type {GetAvailableIdType}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly idType?: GetAvailableIdType

    /**
     * 
     * @type {string}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly originId?: string

    /**
     * 
     * @type {string}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly destinationId?: string

    /**
     * 
     * @type {string}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly date?: string

    /**
     * 
     * @type {number}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {SearchPriority}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly searchPriority?: SearchPriority

    /**
     * 
     * @type {boolean}
     * @memberof JourneyApiApiGetAvailableGet
     */
    readonly restrictServices?: boolean
}

/**
 * Request parameters for apiRegisterInfoPost operation in JourneyApi.
 * @export
 * @interface JourneyApiApiRegisterInfoPostRequest
 */
export interface JourneyApiApiRegisterInfoPostRequest {
    /**
     * 
     * @type {RegisterInfoRequest}
     * @memberof JourneyApiApiRegisterInfoPost
     */
    readonly registerInfoRequest?: RegisterInfoRequest
}

/**
 * Request parameters for apiReservePost operation in JourneyApi.
 * @export
 * @interface JourneyApiApiReservePostRequest
 */
export interface JourneyApiApiReservePostRequest {
    /**
     * 
     * @type {ReserveRequest}
     * @memberof JourneyApiApiReservePost
     */
    readonly reserveRequest?: ReserveRequest
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function JourneyApiApiCitiesGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await JourneyApiApiCitiesGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<City>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {JourneyApiApiGetAvailableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function JourneyApiApiGetAvailableGet(requestParameters: JourneyApiApiGetAvailableGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await JourneyApiApiGetAvailableGetAxiosParamCreator(requestParameters.idType, requestParameters.originId, requestParameters.destinationId, requestParameters.date, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.searchPriority, requestParameters.restrictServices, options, configuration);
    const request: () => AxiosPromise<AvailableJourneysDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {JourneyApiApiRegisterInfoPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function JourneyApiApiRegisterInfoPost(requestParameters: JourneyApiApiRegisterInfoPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await JourneyApiApiRegisterInfoPostAxiosParamCreator(requestParameters.registerInfoRequest, options, configuration);
    const request: () => AxiosPromise<RegisterInfoResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {JourneyApiApiReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function JourneyApiApiReservePost(requestParameters: JourneyApiApiReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await JourneyApiApiReservePostAxiosParamCreator(requestParameters.reserveRequest, options, configuration);
    const request: () => AxiosPromise<ReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
